// Slovak dictionary — must stay structurally identical to en.js.
const sk = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Zažite bedmintonové turnaje v krásnom meste Trenčín',
    info: 'INFO',
    book: 'REZERVOVAŤ UBYTOVANIE',
  },

  home: {
    upcomingTitle: 'Nadchádzajúce podujatia v roku 2026',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Už čoskoro',
    eventDateShort: '25.–27. septembra',
  },

  tournament: {
    entryDeadline: 'Uzávierka prihlášok:',
    upcoming: 'Už čoskoro',
    deadlineU17: '25. augusta 2026',
    deadlineU13: '11. septembra 2026',
    eventDate: '25.–27. septembra 2026',
    invitation: 'POZVÁNKA',
    register: 'REGISTRÁCIA',
    draws: 'ŽREBOVANIE',
    acceptanceList: 'ZOZNAM ÚČASTNÍKOV',
    infoTitle: 'Informácie o turnaji',
    entryFees: 'Štartovné:',
    singles25: 'Dvojhra = 25 €',
    singles40: 'Dvojhra = 40 €',
    doubles20: 'Štvorhra = 20 € / hráč',
    doubles30: 'Štvorhra = 30 € / hráč',
    feesPayment: 'Štartovné je potrebné uhradiť bankovým prevodom pred podujatím alebo v hotovosti (EUR) organizátorovi počas podujatia.',
    shuttlesLabel: 'Oficiálne košíky turnaja:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'Na každý zápas budú poskytnuté 2 košíky, ďalšie si účastníci zabezpečujú sami. Košíky KAWASAKI SHUTTLECOCK TEAM 1 je možné zakúpiť u organizátora.',
    managersMeeting: 'Porada vedúcich družstiev:',
    meetingU17: 'Štvrtok 24. septembra 2026 o 19:00 v mieste konania.',
    mainEvent: 'Hlavná súťaž',
    finals: 'Finále',
    provisionalNote: 'ⓘ Predbežné časy sa môžu zmeniť v závislosti od počtu prihlásených. Konečný časový harmonogram (s presným plánovaným záverom všetkých zápasov) bude zverejnený na webe najneskôr 20 dní pred začiatkom turnaja.',
    seedingNote: 'Nasadenie a žrebovanie boli vykonané podľa rebríčka BEC European U17 zo 17. septembra.',
    koSystemNote: 'Dvojhry sa v prvej fáze hrajú v skupinách a následne vyraďovacím (KO) systémom; štvorhry sa hrajú vyraďovacím systémom. V prípade akéhokoľvek sporu je rozhodnutie hlavného rozhodcu konečné.',
    day25: '25. septembra',
    day26: '26. septembra',
    day27: '27. septembra',
  },

  info: {
    heroTitle: 'Informácie',
    contactsTitle: 'Kontakty a poloha',
    director: 'Riaditeľ turnaja:',
    contactPerson: 'Kontaktná osoba:',
    phoneNumber: 'Telefón:',
    email: 'Email:',
    venue: 'Miesto konania:',
    transportTitle: 'Doprava',
    transportIntro: 'Organizátor zabezpečuje dopravu za poplatok z:',
    transportDetails: 'Údaje o svojej ceste pošlite čo najskôr na sj.bedminton@gmail.com. Poplatky za dopravu je potrebné uhradiť bankovým prevodom pred podujatím alebo v hotovosti (EUR) organizátorovi počas podujatia.',
    transportWalking: 'Všetky oficiálne hotely sú v pešej vzdialenosti od miesta konania, preto sa doprava medzi halou a hotelmi nezabezpečuje.',
    mealsDesc: 'Reštaurácia je súčasťou haly. Obedy a večere sa podávajú formou bufetu s výberom jedál – all you can eat:',
    transportBa: 'Letisko BRATISLAVA = 30 € / osoba / jeden smer',
    transportVie: 'Letisko VIEDEŇ = 40 € / osoba / jeden smer',
    accomTitle: 'Ubytovanie',
    accomOrder: 'Ubytovanie sa objednáva priamo cez náš online rezervačný formulár.',
    accomPayment: 'Ubytovanie je potrebné uhradiť bankovým prevodom pred turnajom alebo v hotovosti (EUR) organizátorovi hneď po príchode do športovej haly. Platí sa za izbu, nie za osobu.',
    breakfastIncluded: 'Raňajky v cene',
    doubleRoom85: 'Dvojlôžková izba = 85 €/noc',
    tripleRoom100: 'Trojlôžková izba = 100 €/noc',
    fourRoom110: 'Štvorlôžková izba = 110 €/noc',
    doubleRoom95: 'Dvojlôžková izba = 95 €/noc',
    tripleRoom110: 'Trojlôžková izba = 110 €/noc',
    singleRoom65: 'Jednolôžková izba = 65 €/noc',
    apartment170: 'Apartmán (2 – 4 osoby) = 170 €/noc',
    apartmentMinStay: 'Minimálny pobyt = 3 noci. Raňajky v cene.',
    apartmentDesc: 'Apartmán obsahuje: 2 samostatné dvojlôžkové izby, kúpeľňu, kuchyňu, obývaciu izbu, práčku.',
    distVenue: 'Priamo v mieste konania.',
    dist14: '1,4 km od miesta konania.',
    dist19: '1,9 km od miesta konania.',
    servicesTitle: 'Ďalšie služby',
    stringing: 'Vypletanie rakiet:',
    stringingAvail: 'K dispozícii počas celého podujatia:',
    stringingOnly: 'Vypletenie = 10 €',
    stringingNew: 'Vypletenie + nový výplet = 18 €',
    meals: 'Strava:',
    lunch: 'Obed = 12 €',
    dinner: 'Večera = 12 €',
  },

  booking: {
    headerTitle: 'Rezervácia ubytovania',
    headerSub: 'Slovak Junior & Youth · Trenčín',
    step1Title: 'Vyberte turnaj',
    underAge: (age) => `Do ${age} rokov`,
    contactTitle: 'Kontaktné údaje',
    firstName: 'Meno',
    lastName: 'Priezvisko',
    phone: 'Telefón',
    email: 'Email',
    emailInvalid: 'Zadajte platnú emailovú adresu',
    selectCountry: 'Vyberte krajinu',
    searchCountry: 'Hľadať krajinu…',
    chooseHotel: 'Vyberte hotel',
    checkingAvail: 'overujem dostupnosť…',
    availUnknown: 'Dostupnosť sa nepodarilo overiť — zobrazené počty nemusia byť aktuálne.',
    unavailable: 'Obsadené',
    selfCatering: 'Bez stravy',
    breakfast: 'Raňajky v cene',
    atVenue: 'V mieste konania · 0 km',
    fromVenue14: '1,4 km od miesta konania',
    fromVenue19: '1,9 km od miesta konania',
    rooms: 'Izby',
    perNight: '€ / noc',
    addRoom: 'Pridať izbu',
    soldOut: 'Vypredané',
    minNights3: 'Pri apartmánoch je minimálny pobyt 3 noci.',
    noRoomsLeft: 'V tomto hoteli už nie sú voľné izby',
    onlyRoomsLeft: (n) => `V tomto hoteli ${n === 1 ? 'zostáva už len 1 izba' : `zostávajú už len ${n} izby`}`,
    roomsAvailable: (n, total) => `Voľné izby: ${n} z ${total}`,
    selectedRooms: 'Vybrané izby',
    remove: 'Odstrániť',
    checkin: 'Príchod',
    checkout: 'Odchod',
    nights: (n) => `${n} ${n === 1 ? 'noc' : n < 5 ? 'noci' : 'nocí'}`,
    personFirst: (i) => i === 1 ? 'Meno (osoba 1)' : `Meno (osoba ${i}, nepovinné)`,
    personLast: (i) => i === 1 ? 'Priezvisko (osoba 1)' : `Priezvisko (osoba ${i}, nepovinné)`,
    addAnotherRoom: 'Pridať ďalšiu izbu',
    summaryTitle: 'Zhrnutie rezervácie',
    tournamentLabel: 'Turnaj:',
    hotelLabel: 'Hotel:',
    contactLabel: 'Kontakt:',
    phoneLabel: 'Telefón:',
    emailLabel: 'Email:',
    person: 'Osoba',
    estimatedTotal: 'Cena spolu',
    paymentNote: 'Ubytovanie je potrebné uhradiť bankovým prevodom pred turnajom alebo v hotovosti (EUR) pri príchode. Platí sa za izbu, nie za osobu.',
    overFull: (hotel) => `${hotel} sa práve vypredal — vráťte sa späť a vyberte iný hotel.`,
    overSome: (n, hotel, remove) => `V hoteli ${hotel} ${n === 1 ? 'zostáva už len 1 izba' : `zostávajú už len ${n} izby`} — odstráňte ${remove} ${remove === 1 ? 'izbu' : remove < 5 ? 'izby' : 'izieb'} alebo vyberte iný hotel.`,
    btnContact: 'Kontaktné údaje',
    btnHotel: 'Vybrať hotel',
    btnRoom: 'Vybrať izbu',
    btnGuests: 'Pridať hostí',
    btnReview: 'Zhrnutie a odoslanie',
    btnSubmit: 'Odoslať rezerváciu',
    btnSubmitting: 'Odosielam…',
    btnBack: 'Späť',
    btnClose: 'Zavrieť',
    successTitle: 'Rezervácia odoslaná!',
    successText: 'Vaša požiadavka na ubytovanie bola prijatá. Organizátor ju potvrdí a pošle platobné pokyny na váš email.',
    confirmHotelChange: 'Zmenou hotela sa odstránia vybrané izby. Pokračovať?',
    submitError: 'Ľutujeme, pri odosielaní rezervácie nastala chyba. Skúste to prosím znova.',
    roomTypes: {
      'Single room': 'Jednolôžková izba',
      'Double room': 'Dvojlôžková izba',
      'Triple room': 'Trojlôžková izba',
      '4-person room': 'Štvorlôžková izba',
      'Apartment (2-4 persons)': 'Apartmán (2 – 4 osoby)',
    },
  },

  reg: {
    notOpen: 'Registrácia ešte nie je otvorená.',
    headerTitle: 'Registrácia na turnaj',
    step1Title: 'Klub a kontakt',
    club: 'Názov klubu',
    country: 'Krajina',
    managerTitle: 'Vedúci družstva',
    singlesTitle: 'Prihlášky — dvojhry',
    doublesTitle: 'Prihlášky — štvorhry',
    addSingles: 'Pridať hráča do dvojhry',
    addDoubles: 'Pridať pár do štvorhry',
    noEntries: 'Zatiaľ žiadne prihlášky — tento krok môžete preskočiť.',
    player1: 'Hráč 1',
    player2opt: 'Hráč 2 (nepovinné)',
    partnerNote: 'Prihláška do štvorhry je platná aj s jedným hráčom — partnera možno doplniť neskôr.',
    discipline: 'Disciplína',
    disciplines: {
      BS: 'Dvojhra — chlapci',
      GS: 'Dvojhra — dievčatá',
      BD: 'Štvorhra — chlapci',
      GD: 'Štvorhra — dievčatá',
      XD: 'Zmiešaná štvorhra',
    },
    summaryTitle: 'Zhrnutie registrácie',
    clubLabel: 'Klub:',
    entriesLabel: 'Prihlášky:',
    entriesCount: (n) => `${n} ${n === 1 ? 'prihláška' : n < 5 ? 'prihlášky' : 'prihlášok'}`,
    needOneEntry: 'Pred odoslaním pridajte aspoň jednu prihlášku (dvojhra alebo štvorhra).',
    btnSingles: 'Dvojhry',
    btnDoubles: 'Štvorhry',
    btnSubmit: 'Odoslať registráciu',
    successTitle: 'Registrácia odoslaná!',
    successText: 'Vaše prihlášky boli prijaté. Organizátor potvrdí registráciu e-mailom.',
  },
};

export default sk;
